import { cn, cva } from 'noddi-ui-common';
import { getDepartmentOrganizationDisplay } from './getDepartmentOrganizationDisplay';

type Props = {
  departmentName: string;
  organizationName: string;
  className?: string;
  tone?: 'default' | 'brand';
};

const organizationNameStyles = cva('truncate text-sm font-normal', {
  variants: {
    tone: {
      default: 'text-muted-foreground',
      brand: 'text-primary/75'
    }
  },
  defaultVariants: { tone: 'default' }
});

export const DepartmentOrganizationName = ({
  departmentName,
  organizationName,
  className,
  tone = 'default'
}: Props) => {
  const { primaryName, secondaryName } = getDepartmentOrganizationDisplay(departmentName, organizationName);

  return (
    <span className={cn('flex min-w-0 flex-col text-start', className)}>
      <span className='truncate font-semibold'>{primaryName}</span>
      {secondaryName && <span className={organizationNameStyles({ tone })}>{secondaryName}</span>}
    </span>
  );
};
